module.exports = __webpack_public_path__ + "img/3c4e5e156ecd0e01f52b08d3efad6394.png";